/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useCallback,
    useEffect,
    useState,
    useContext
} from 'react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { PolicyChange } from 'gw-capability-policychange-common-react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { MLModalService } from 'ml-portals-services-react';
import { Tooltip } from '@jutro/components';
import { MLEndorsementFlowUtil, MLEndorsementUtil } from 'ml-portals-util-js';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLAvailableInsuredCandidatesUtil } from 'ml-portals-util-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import { MLPolicyChangeDataHolderService, MLNavigationStepsTrackingService } from 'ml-services-common-react';
import { MLInsuredCandidatesComponent } from 'ml-components-common-react';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import MLPartialDriverDetailsComponent from '../../components/MLPartialDriverDetailsComponent/MLPartialDriverDetailsComponent';
import MLReasonComponent from '../../components/MLReasonComponent/MLReasonComponent';
import metadata from './PAHouseholdMembersPagePolChange.metadata.json5';

import messages from './PAHouseholdMembersPagePolChange.messages';
import styles from './PAHouseholdMembersPagePolChange.module.scss';
import { Link } from '@jutro/router';

import { ScrollToError } from '@jutro/legacy/wizard-next';

const alertNames = {
    addedHouseholdMemberName: 'addedHouseholdMember',
    removedHouseholdMemberName: 'removedHouseholdMember',
    excludedDriverName: 'excludedDriver',
    exclusionNotAllowed: 'exclusionNotAllowed',
    excludingHouseholdMemberSameAsNamedInsuredAlert: 'excludingHouseholdMemberSameAsNamedInsuredAlert',
    excludingHouseholdMemberSameAsSecondNamedInsuredAlert: 'excludingHouseholdMemberSameAsSecondNamedInsuredAlert'
};

const PAHouseholdMembersPagePolChange = (props) => {
    const {
        wizardData,
        updateWizardData,
        goNext,
        currentStepIndex,
        steps,
        changeNextSteps,
        currentStep
    } = props;
    const { submissionVM, alertMessages } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();

    const { refreshData } = useDataRefresh();

    const {
        showProgressDialog
    } = MLModalService();

    const {
        clearBlockAlerts,
        addErrorAlert
    } = MLNotificationBlockUtil();

    const {
        isDriverRemovalExclusion,
        isDriverRemovalNotInHousehold,
        isDriverRemovalDuplicate,
        getExcludedDriverType,
        getHouseholdDriverType,
        getRatedDriverType,
        isDriverRemovalAddRatedDriver,
        checkUniqueSelf,
        checkUniqueSpouse,
        validateExcludedDriverAddition,
        getFullName,
        getHouseholdNonDriverType
    } = MLDriverVehicleUtil();

    const {
        addRemovedDriverToAvailableCandidates
    } = MLAvailableInsuredCandidatesUtil();

    const isGPA = appConfig.portalCode === 'GPA';
    const isAMP = appConfig.portalCode === 'AMP';
    const DRIVERS_PATH = 'lobData.personalAuto.coverables.drivers';
    const driversVM = _.get(submissionVM, DRIVERS_PATH, []);
    const driversVal = _.get(submissionVM, `${DRIVERS_PATH}.value`, {});
    const paCoverableVal = _.get(submissionVM, 'lobData.personalAuto.coverables.value', {});
    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const stateValue = _.get(submissionVM, 'baseData.policyAddress.state', false);

    const [pageAction, setPageAction] = useState(currentStep.driverType || MLPolicyChangeDataHolderService.getDriverType());
    const [member, setMember] = useState(viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.DriverDTO'));
    const [oldMemberStatus, setOldMemberStatus] = useState(null);
    const [error, setError] = useState(null);
    const [showValidationErrors, setShowValidationErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [insuredCandidateSelected, setInsuredCandidateSelected] = useState(false);
    const [isBackwardsNavigation, setIsBackwardsNavigation] = useState(false);

    const { onValidate } = useValidation('PAHouseholdMembersPagePolChange');

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const addNewHouseholdMember = () => {
        const newMember = paCoverableVal.createDriver();
        newMember.person.primaryAddress = submissionVM.baseData.policyAddress.value;
        newMember.editMode_ML = true;
        newMember.type_ML = 'household';
        newMember.isAgentCreated = true;
        return driversVM.findFirstElement(newMember);
    };

    const getSelectedDriver = () => {
        let index = driversVal.findIndex((drv) => drv.isSelected === true);
        if (index === -1) {
            index = driversVal.findIndex((drv) => drv.fixedId === currentStep.fixedId);
        }
        if (index === -1) {
            return addNewHouseholdMember();
        }
        setIsBackwardsNavigation(true);
        setInsuredCandidateSelected(true);

        return driversVM.getElement(index);
    };

    const setCurrentHouseholdMemberVM = () => {
        switch (MLPolicyChangeDataHolderService.getPageAction()) {
            case 'add': {
                setPageAction('add');
                setMember(getSelectedDriver());
                if (isModernProduct) {
                    MLNavigationStepsTrackingService.addToDynamicSteps(_.startCase(translator(messages.addNonDriver)), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                } else {
                    MLNavigationStepsTrackingService.addToDynamicSteps(_.startCase(translator(messages.addHouseholdMember)), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                }
                break;
            }
            case 'edit': {
                setPageAction('edit');
                const selectedEditMember = getSelectedDriver();
                selectedEditMember.value.isAgentCreated = true; // Makes help text next to DOB not show
                selectedEditMember.value.editMode_ML = true;
                setMember(selectedEditMember);
                setOldMemberStatus(selectedEditMember.value.status_ML);
                if (isModernProduct) {
                    MLNavigationStepsTrackingService.addToDynamicSteps(_.startCase(translator(messages.editNonDriver)), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                } else {
                    MLNavigationStepsTrackingService.addToDynamicSteps(_.startCase(translator(messages.editHouseholdMember)), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                }
                break;
            }
            case 'remove': {
                setPageAction('remove');
                const selectedRemoveMember = getSelectedDriver();
                setMember(selectedRemoveMember);
                setOldMemberStatus(selectedRemoveMember.value.status_ML);
                if (isModernProduct) {
                    MLNavigationStepsTrackingService.addToDynamicSteps(_.startCase(translator(messages.removeNonDriver)), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                } else {
                    MLNavigationStepsTrackingService.addToDynamicSteps(_.startCase(translator(messages.removeHouseholdMember)), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                }
                break;
            }
            default:
                break;
        }
    };

    const initHouseholdMemberPage = () => {
        if (alertMessages.length > 0) {
            const poppedAlert = alertMessages.pop();
            clearBlockAlerts(poppedAlert.alertName);
        }
        if (currentStep.pageAction) {
            MLPolicyChangeDataHolderService.setPageAction(currentStep.pageAction);
        }
        if (currentStep.driverType) {
            MLPolicyChangeDataHolderService.setDriverType(currentStep.driverType);
        }
        setCurrentHouseholdMemberVM();
    };

    useEffect(() => {
        if (MLEndorsementFlowUtil.startingPointPageLoadIsSkipping(submissionVM, goNext, steps, currentStepIndex, changeNextSteps)) {
            return;
        };
        initHouseholdMemberPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isGPA) {
            PolChangeTrackEvent('Endorsement Step Reached', false, submissionVM, authHeader, { step: 'PolChange Household Members Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getNextStepText = () => {
        return (
            <FormattedMessage
                {...messages.nextBaseDescription}
                values={{
                    bold: (
                        <strong>{translator(messages.nextDescriptionBold)}</strong>
                    )
                }}
            />
        );
    };

    const isSecondaryNamedInsuredErrorMessage = (errorMsg) => {
        return errorMsg === translator(messages.notValidToRemoveHouseholdMember);
    };

    const undoHouseholdRemoval = (removedMember) => {
        removedMember.isSelected = false;
        driversVM.pushElement(removedMember);
        const poppedAlert = alertMessages.pop();
        clearBlockAlerts(poppedAlert.alertName);
    };

    const undoHouseholdExclusion = (selectedMember, originalMember) => {
        selectedMember.type_ML = originalMember.type_ML;
        selectedMember.status_ML = originalMember.status_ML;
        const poppedAlert = alertMessages.pop();
        clearBlockAlerts(poppedAlert.alertName);
        updateWizardSubmissionData(submissionVM);
    };

    const addExcludingNamedInsuredAlert = (errorMsg) => {
        if (isAMP && isSecondaryNamedInsuredErrorMessage(errorMsg)) {
            const help = {
                title: translator(messages.whatIsSecondaryNamedInsured),
                message: translator(messages.definitionOfSecondaryNamedInsured)
            };
            addErrorAlert(errorMsg, alertNames.excludingHouseholdMemberSameAsSecondNamedInsuredAlert, help.title, help.message);
        } else {
            addErrorAlert(errorMsg, alertNames.excludingHouseholdMemberSameAsNamedInsuredAlert);
        }
    };

    const addHouseholdAlert = (selectedMember) => {
        const alertMsg = {
            alertName: alertNames.addedHouseholdMemberName,
            formattedMessageName: isModernProduct ? 'driverHasBeenAddedAsNonDriver' : 'driverHasBeenAddedAsHouseholdMember',
            messagePram: selectedMember.getDisplayName()
        };
        alertMessages.push(alertMsg);
    };

    const addExcludedAlert = (selectedMember, originalMember) => {
        const help = {
            title: translator(messages.driverExclusionHelpTitle),
            message: translator(messages.driverExclusionHelpText)
        };

        const alertMsg = {
            alertName: alertNames.excludedDriverName,
            formattedMessageName: 'driverExcludedNotCovered',
            messagePram: selectedMember.getDisplayName(),
            actionFn: () => undoHouseholdExclusion(selectedMember, originalMember),
            help: help
        };
        alertMessages.push(alertMsg);
    };

    const addExclusionNotAllowedAlert = () => {
        const alertMsg = {
            type: 'warning',
            alertName: alertNames.exclusionNotAllowed,
            message: isModernProduct ? translator(messages.nonDriverListedAsDriver) : translator(messages.personListedAsDriver)
        };
        alertMessages.push(alertMsg);
    };

    const removeHouseholdAlert = (removedMember) => {
        const alertMsg = {
            alertName: alertNames.removedHouseholdMemberName,
            formattedMessageName: 'driverHasBeenRemoved',
            messagePram: removedMember.getDisplayName(),
            actionFn: () => undoHouseholdRemoval(removedMember)
        };
        alertMessages.push(alertMsg);
    };

    const getFormattedTooltipContent = () => {
        return (
            <>
                <h3 className={styles['tooltip-header']}>
                    {translator(messages.whatIsSecondaryNamedInsured)}
                </h3>
                <div>
                    {translator(messages.definitionOfSecondaryNamedInsured)}
                </div>
            </>
        );
    };

    const jumpToSelectedStepByStepID = (newStepID) => {
        MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, steps, currentStepIndex, changeNextSteps, goNext, productCode);
    };

    const saveEndorsement = () => {
        let promise ;
        const tempDriver = viewModelService.create({...member.value}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.DriverDTO');

        if((tempDriver.value.type_ML !== "household") && (!tempDriver.aspects.valid || !tempDriver.aspects.subtreeValid) ){
            // To Avoid Making call to PC to remove DTO Error if DOB is Invalid and to use the Promise.then without disturbing the existing structure
            promise = Promise.resolve()
        }else{
            promise = EndorsementService.saveEndorsement([submissionVM.value], authHeader);
        }

        showProgressDialog(messages.saving, promise);
        promise.then((updatedPolicyChange = submissionVM.value) => {
            setError(null);
            const policyChange = new PolicyChange(Object.assign({}, updatedPolicyChange));
            const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');

            const index = updatedEndorsementVM.lobData.personalAuto.coverables.drivers.value.findIndex(
                (drv) => drv.fixedId === member.fixedId.value || driversVal.findIndex((driverVal) => driverVal.fixedId === drv.fixedId) === -1);
            const selectedDriver = updatedEndorsementVM.lobData.personalAuto.coverables.drivers.getElement(index);

            const details = {
                data: getFullName(selectedDriver.person.value),
                fixedId: selectedDriver.fixedId.value,
                pageAction,
                driverType: 'household'
            };

            updateWizardSubmissionData(updatedEndorsementVM);
            MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader);
            
            if (MLPolicyChangeDataHolderService.getPageAction() === 'remove' && ( member.type_ML.value.code === getRatedDriverType() ||  member.type_ML.value.code === getExcludedDriverType())) {
                MLPolicyChangeDataHolderService.setPageAction('edit');
                MLPolicyChangeDataHolderService.setDriver(member.value);
                selectedDriver.value.isSelected = true;
                _.set(updatedEndorsementVM, 'value.stayOnStepML', true);
                updateWizardSubmissionData(updatedEndorsementVM);
                
                if(member.type_ML.value.code === getExcludedDriverType()){
                    MLPolicyChangeDataHolderService.setDriverType('excluded');
                    jumpToSelectedStepByStepID('endorsementPaExcludedDrivers');
                }else{
                    MLPolicyChangeDataHolderService.setDriverType('rated');
                    jumpToSelectedStepByStepID('endorsementPaDrivers');
                }
               
                return;
            }
            
            jumpToSelectedStepByStepID('endorsementAdditionalChanges');
        }).catch((e) => {
            setError(e.baseError);
        });
    };

    const onNext = () => {
        const isValid = checkUniqueSelf(driversVal) && checkUniqueSpouse(driversVal) && submissionVM.aspects.valid && submissionVM.aspects.subtreeValid;
        if (!isValid) {
            setShowValidationErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            return;
        }

        let removedMember;
        let errorMsg = null;
        setError(null);
        clearBlockAlerts(alertNames.excludingHouseholdMemberSameAsNamedInsuredAlert);
        if (member.aspects.valid && member.aspects.subtreeValid) {
            if (MLPolicyChangeDataHolderService.getPageAction() === 'remove') {
                if (isDriverRemovalExclusion(member.value)) {
                    const excludingHouseholdMemberValidationResult = validateExcludedDriverAddition(member, submissionVM, driversVal);
                    if (excludingHouseholdMemberValidationResult.hasError) {
                        addExcludingNamedInsuredAlert(excludingHouseholdMemberValidationResult.errorMessage);
                        return;
                    }
                    if (excludingHouseholdMemberValidationResult || !excludingHouseholdMemberValidationResult.hasError) {
                        clearBlockAlerts(alertNames.excludingHouseholdMemberSameAsNamedInsuredAlert);
                    }
                }

                const isStateKS = () => submissionVM.baseData.policyAddress.state.value.code === 'KS';
                const isStateWI = () => submissionVM.baseData.policyAddress.state.value.code === 'WI';

                const householdReasons = ['never_licensed', 'abroad', 'own_insurance'];
                const nonDriverReasons = ['unknown', 'deceased', 'abroad', 'mission', 'permit', 'not_household'];
                const householdReasonsNP = ['never_licensed', 'own_insurance', 'registeredowner', 'unabletodrive'];

                const isHouseholdReason = householdReasons.indexOf(member.value.status_ML) > -1;
                const isNonDriverReason = nonDriverReasons.indexOf(member.value.status_ML) > -1;
                if ((!isModernProduct && isHouseholdReason) || (isModernProduct && isNonDriverReason) || (isModernProduct && householdReasonsNP &&  (isStateKS() || isStateWI()))) {
                    errorMsg = isModernProduct ? translator(messages.reasonSelectedIsNotValidNonDriver) : translator(messages.reasonSelectedIsNotValid);
                    setError(errorMsg);
                } else if (isDriverRemovalExclusion(member.value, isModernProduct) && member.relationshipToInsured_ML.value.code === 'spouse') {
                    errorMsg = translator(messages.licensedCannotBeExcluded);
                    setError(errorMsg);
                } else if (isDriverRemovalNotInHousehold(member.value) || isDriverRemovalDuplicate(member.value)) {
                    // save and set old status in case of undo hit on additional changes page
                    removedMember = _.cloneDeep(member.value);
                    _.set(removedMember, 'status_ML', oldMemberStatus);
                    addRemovedDriverToAvailableCandidates(submissionVM, member.value);
                    paCoverableVal.removeDriver(member.value);
                    removeHouseholdAlert(removedMember);
                } else if (isDriverRemovalExclusion(member.value, isModernProduct)) {
                    const selectedMember = getSelectedDriver();
                    if (submissionVM.baseData.canExcludeDrivers_ML.value) {
                        const originalMember = {...member.value, status_ML: oldMemberStatus};
                        _.set(selectedMember, 'value.type_ML', getExcludedDriverType());
                        addExcludedAlert(selectedMember.value, originalMember);
                    } else {
                        _.set(selectedMember, 'value.type_ML', getRatedDriverType());
                        addExclusionNotAllowedAlert();
                    }
                } else if (isDriverRemovalAddRatedDriver(member.value)) {
                    const selectedMember = getSelectedDriver();
                    _.set(selectedMember, 'value.type_ML', getRatedDriverType());
                }

                if (removedMember) {
                    const details = {
                        data: removedMember.getDisplayName(),
                        fixedId: removedMember.fixedId,
                        pageAction
                    };
                    MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader);
                    jumpToSelectedStepByStepID('endorsementAdditionalChanges');
                    return;
                }
            } else if (isDriverRemovalExclusion(member.value, isModernProduct) && ((stateValue.value.code !== 'KS' || stateValue.value.code !== 'WI') && MLPolicyChangeDataHolderService.getPageAction() === 'edit')) {
                const excludingHouseholdMemberValidationResult = validateExcludedDriverAddition(member, submissionVM, driversVal);
                // Now there is no way to add excluded driver by adding household member but full dropdown may come back in the future
                if (excludingHouseholdMemberValidationResult.hasError) {
                    addExcludingNamedInsuredAlert(excludingHouseholdMemberValidationResult.errorMessage);
                    return;
                }
                if (excludingHouseholdMemberValidationResult || !excludingHouseholdMemberValidationResult.hasError) {
                    clearBlockAlerts(alertNames.excludingHouseholdMemberSameAsNamedInsuredAlert);
                }

                const excludedMember = {...member.value, status_ML: oldMemberStatus};
                const selectedMember = getSelectedDriver();
                if (!(stateValue.value.code === 'OR' && member.value.type_ML === 'nondriver')) {
                    _.set(selectedMember, 'value.type_ML', getExcludedDriverType());
                    addExcludedAlert(selectedMember.value, excludedMember);
                }
            } else if (MLPolicyChangeDataHolderService.getPageAction() === 'add') {
                _.set(member, 'value.type_ML', getHouseholdNonDriverType(member.value, isModernProduct, submissionVM.baseData?.canExcludeDrivers_ML?.value, submissionVM.baseData.policyAddress.state.value.code));
                addHouseholdAlert(member.value);
            }

            if (!errorMsg) {
                const lbl = MLEndorsementUtil.stepLabel(currentStep);
                MLEndorsementUtil.setEndorsementDescription(lbl, submissionVM, translator);
                saveEndorsement();
            }
        }

        if (isGPA) {
            PolChangeTrackEvent('Endorsement Step Submitted', false, submissionVM, authHeader, {
                step: 'PolChange Household Members Screen',
                action: 'Household Members Submitted'
            });
        }
    };

    const resolvers = {
        resolveComponentMap: {
            mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
            mlpartialdriverdetailscomponent: MLPartialDriverDetailsComponent,
            mlreasoncomponent: MLReasonComponent
        },
        resolveCallbackMap: {
            onNext
        },
        resolveClassNameMap: styles
    };

    const overrides = {
        householdMemberNotification: {
            visible: !_.isEmpty(error),
            message: (
                <>
                    <strong>{error}</strong>
                    {
                        isAMP && isSecondaryNamedInsuredErrorMessage(error) && (
                            <Tooltip
                                id="householdMemberTooltip"
                                placement="right"
                                trigger="click"
                                content={getFormattedTooltipContent()}
                            >
                                <Link onClick={_.noop()}>
                                    {messages.whatIsSecondaryNamedInsured}
                                </Link>
                            </Tooltip>
                        )
                    }
                </>
            )
        },
        contentContainer: {
            className: isGPA ? 'page-content-gpa' : ''
        },
        addEditContainer: {
            visible: pageAction === 'add' || pageAction === 'edit'
        },
        addEditHeaderContainer: {
            content: isModernProduct ? (translator( pageAction === 'add' ? messages.addNonDriver : messages.editNonDriver)) : (translator(pageAction === 'add' ? messages.addHouseholdMember : messages.editHouseholdMember))
        },
        insuredCandidatesComponent: {
            visible: pageAction === 'add' && !isBackwardsNavigation,
            submissionVM,
            driverVM: member,
            driverType: getHouseholdDriverType(),
            setInsuredCandidateSelected,
            onValueChange: refreshData,
            viewModelService
        },
        formFieldsContainer: {
            visible: insuredCandidateSelected || pageAction !== 'add'
        },
        partialDriverDetailsComponent: {
            driver: member,
            checkUniqueSelf: () => checkUniqueSelf(driversVal),
            checkUniqueSpouse: () => checkUniqueSpouse(driversVal),
            onValidate,
            showValidationErrors,
            submissionVM,
            viewModelService
        },
        reasonAddEditComponent: {
            driver: member,
            onValidate,
            showValidationErrors,
            viewModelService,
            translator,
            isModernProduct
        },
        removeContainer: {
            visible: pageAction === 'remove'
        },
        removeHeaderContainer: {
            content: isModernProduct ? translator(messages.removeNonDriver) : translator(messages.removeHouseholdMember)
        },
        reasonRemoveComponent: {
            driver: member,
            removeAction: true,
            onValidate,
            showValidationErrors,
            viewModelService,
            translator,
            isModernProduct
        },
        nextDescription: {
            content: getNextStepText()
        },
        nextButton:{
            disabled : pageAction === 'add' && !insuredCandidateSelected
        },
        stickyContinueSection: {
            visible: isGPA,
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText(),
            onNext
        }
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            policyChangePageHeaderML={isGPA ? messages.makeChanges: null}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
                showErrors={showValidationErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

PAHouseholdMembersPagePolChange.propTypes = wizardProps;
export default PAHouseholdMembersPagePolChange;